<template>
    <div v-if="ShowBio" class="modal bio-modal port-modal fade" role="dialog">
        <div class="modal-dialog modal-lg">

            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-bs-dismiss="modal">Close</button>
                </div>

                <div v-if="Bio?.HeroImageUrl" class="modal-title">
                    <div class="contact-hero-image" :style="'background-image: url(' + Bio.HeroImageUrl + ')'">
                        <div class="contact-name">{{ FullName }}</div>

                        <div v-if="ShowTitle" class="contact-title">{{ Title }}</div>
                    </div>
                </div>

                <div v-if="Bio?.Content" class="modal-body" v-html="Bio.Content"></div>
            </div>

        </div>
    </div>
</template>

<script setup>
    import { computed, inject } from 'vue';
    import { useWidgetConfig } from '../useWidgetConfig';

    defineOptions({
        inheritAttrs: false
    })

    const props = defineProps({
        Id: [String, Number],
        FullName: String,
        Title: String,
        Bio: Object,
        config: Object
    })

    const { configFlag } = useWidgetConfig(props.config);

    const ShowTitle = configFlag('IncludeTitle', () => props.Title)
    const ShowBio = configFlag('IncludeBio', () =>
        !!props.Bio &&
        (!!props.Bio.Content || !!props.Bio.HeroImageUrl)
    )
</script>